<template>
  <div>
    <span class="UserStaff"
      v-for="e in userList"
      :key="e.id"
      :title="JSON.stringify(e)">{{e.name}}</span>
  </div>
</template>

<script>
export default {
  name: "UserStaff",

  props : ['id'],

  data() {
    return {
      userList : []
    }
  },

  mounted() {
    sdk.TicketUserApi().listStaffByUserId({
      userId : this.id
    }).then(res=>{
      this.userList = res;
    })
  }
}
</script>

<style>
  .UserStaff {
    margin: 2px 2px;
    padding: 0 5px;
    background: #efefef;
    border-radius:5px;
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/setting/UserStaff.vue